import { createContext } from 'react';

import { TimeseriesChartToolbarConfig } from '../types/toolbar.js';

export const TimeseriesToolbarContext = createContext<
  TimeseriesChartToolbarConfig | undefined
>(undefined);

TimeseriesToolbarContext['displayName'] = 'TimeseriesToolbarContext';
